/*
 * @Author: your name
 * @Date: 2021-03-15 15:20:58
 * @LastEditTime: 2021-04-15 11:20:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\pages\index\src\routes\i18n.js
 */
export default {
  'zh-CN': {
    procurementMall: '采购商城',
    myMall: '我的商城',
    myCollection: '我的收藏',
    oftenBuyGoods: '常购商品',
    purchasingCenter: '采购中心',
    myPurchaseRequest: '我的采购申请',
    myOrder: '我的订单',
    myReceipt: '我的收货单',
    myReturn: '我的退货单',
    systemSettings: '系统设置',
    personalInformation: '个人信息',
    passwordChange: '密码修改',
    shippingAddress: '地址管理',
    myEvaluation: '我的评价',
    hereIsMyReceipt: '我的领用单',
    recycleList: '我的利旧单',
    feedBack: '意见反馈',
    requirementList: '我的需求清单',
    myWorkbench: '我的工作台',
    workbench: '工作台'
  },
  en: {
    procurementMall: 'Shopping Mall',
    myMall: 'My mall',
    myCollection: 'My favorites',
    oftenBuyGoods: 'Frequently purchased commodities',
    purchasingCenter: 'Purchasing center',
    myPurchaseRequest: 'My PR',
    myOrder: 'My Orders',
    myReceipt: 'My receipt',
    myReturn: 'My Return',
    systemSettings: 'System settings',
    personalInformation: 'Personal information',
    passwordChange: 'Change password',
    shippingAddress: 'Receiving address',
    myEvaluation: 'My comment',
    hereIsMyReceipt: 'My requisition',
    recycleList: 'My old order',
    feedBack: '意见反馈',
    requirementList: 'My demand list',
    myWorkbench: 'My Workbench',
    workbench: 'Workbench'
  },
  ja: {
  }
}
